import { Toggle } from "../../../../../common/Atoms/Toggle";
import { useGeneralSettingsForm } from "../../../../hooks/useGeneralSettingsForm";
import { TwoColFormRow } from "../../../Molecules/Form/TwoColFormRow";

export function GeneralEmailSettings() {
  const { formData, onChange } = useGeneralSettingsForm();
  function handleChange(e) {
    onChange(e.name, e.value);
  }

  return (
    <TwoColFormRow
      heading={ `General Email Settings` }
    >
      <div className={ `space-y-2` }>
        <Toggle
          className={ `my-1` }
          label={ `Include all contact persons in same email` }
          checked={ formData.consolidateToEmails || false }
          name={ `consolidateToEmails` }
          onChange={ handleChange }
          description={ `When enabled all contact persons for contact will be included in the same email under the "To" field. The name of the primary contact will be used in the email content.` }
        />
      </div>
    </TwoColFormRow>
  );
}
